<template>
    <div>
        <b-row class="pb-2">
            <b-col>
                <h5 class="mb-3"><strong>Financeiro</strong></h5>
                <app-detalhe titulo="Valor Contratado (Não inclui aditamentos)" :xl="xl">
                    <strong>{{
                        dadosEngenharia.financeiro && dadosEngenharia.financeiro.valorContratado
                            ? formatarMoeda(dadosEngenharia.financeiro.valorContratado)
                            : 'R$ 0,00'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Valor Aditado" :xl="xl">
                    <strong>{{
                        dadosEngenharia.financeiro && dadosEngenharia.financeiro.valorAditado
                            ? formatarMoeda(dadosEngenharia.financeiro.valorAditado)
                            : 'R$ 0,00'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Valor do Saldo Contratual" :xl="xl">
                    <strong>{{
                        dadosEngenharia.financeiro && dadosEngenharia.financeiro.valorSaldoContratual
                            ? formatarMoeda(dadosEngenharia.financeiro.valorSaldoContratual)
                            : 'R$ 0,00'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Valor Total" :xl="xl">
                    <strong>{{
                        dadosEngenharia.financeiro && dadosEngenharia.financeiro.valorTotal
                            ? formatarMoeda(dadosEngenharia.financeiro.valorTotal)
                            : 'R$ 0,00'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Valor Total de Reajuste" :xl="xl">
                    <strong>{{
                        dadosEngenharia.financeiro && dadosEngenharia.financeiro.valorTotalReajustamento
                            ? formatarMoeda(dadosEngenharia.financeiro.valorTotalReajustamento)
                            : 'R$ 0,00'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="% Inicial" :xl="xl">
                    <strong>{{
                        dadosEngenharia.financeiro && dadosEngenharia.financeiro.percentualInicial !== undefined
                            ? formatarPercentual(dadosEngenharia.financeiro.percentualInicial)
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="% Aditado" :xl="xl">
                    <strong>{{
                        dadosEngenharia.financeiro && dadosEngenharia.financeiro.percentualAditado !== undefined
                            ? formatarPercentual(dadosEngenharia.financeiro.percentualAditado)
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="% Saldo Contratual" :xl="xl">
                    <strong>{{
                        dadosEngenharia.financeiro && dadosEngenharia.financeiro.percentualSaldoContratual !== undefined
                            ? formatarPercentual(dadosEngenharia.financeiro.percentualSaldoContratual)
                            : '-'
                    }}</strong>
                </app-detalhe>

                <h5 class="mb-3 mt-4"><strong>Valores de acompanhamento</strong></h5>
                <app-detalhe titulo="Valores Acumulados" :xl="xl">
                    <strong>{{
                        dadosEngenharia.acompanhamento && dadosEngenharia.acompanhamento.valoresAcumulados !== undefined
                            ? formatarMoeda(dadosEngenharia.acompanhamento.valoresAcumulados)
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Valores Acumulados RJ" :xl="xl">
                    <strong>{{
                        dadosEngenharia.acompanhamento && dadosEngenharia.acompanhamento.valoresAcumuladosRJ !== undefined
                            ? formatarMoeda(dadosEngenharia.acompanhamento.valoresAcumuladosRJ)
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Valores Acumulados Pagos" :xl="xl">
                    <strong>{{
                        dadosEngenharia.acompanhamento && dadosEngenharia.acompanhamento.valoresAcumuladosPagos !== undefined
                            ? formatarMoeda(dadosEngenharia.acompanhamento.valoresAcumuladosPagos)
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Valores Acumulados RJ Pago" :xl="xl">
                    <strong>{{
                        dadosEngenharia.acompanhamento && dadosEngenharia.acompanhamento.valoresAcumuladosRJPago !== undefined
                            ? formatarMoeda(dadosEngenharia.acompanhamento.valoresAcumuladosRJPago)
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Valores Acumulados Totais Pagos" :xl="xl">
                    <strong>{{
                        dadosEngenharia.acompanhamento && dadosEngenharia.acompanhamento.valoresAcumuladosTotaisPagos !== undefined
                            ? formatarMoeda(dadosEngenharia.acompanhamento.valoresAcumuladosTotaisPagos)
                            : '-'
                    }}</strong>
                </app-detalhe>
            </b-col>
            <b-col>
                <h5 class="mb-3"><strong>Dados contratuais e administrativos</strong></h5>
                <app-detalhe titulo="Procedimento de Licitação" :xl="xl">
                    <strong>{{
                        dadosEngenharia.dadosContratuais && dadosEngenharia.dadosContratuais.procedimentoLicitacao
                            ? dadosEngenharia.dadosContratuais.procedimentoLicitacao
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Vigência Garantia" :xl="xl">
                    <strong>{{
                        dadosEngenharia.dadosContratuais && dadosEngenharia.dadosContratuais.vigenciaGarantia
                            ? formatarData(dadosEngenharia.dadosContratuais.vigenciaGarantia)
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Valor da Garantia" :xl="xl">
                    <strong>{{
                        dadosEngenharia.dadosContratuais && dadosEngenharia.dadosContratuais.valorGarantia
                            ? formatarMoeda(dadosEngenharia.dadosContratuais.valorGarantia)
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Folhas e Guia de Recebimento" :xl="xl">
                    <strong>{{
                        dadosEngenharia.dadosContratuais && dadosEngenharia.dadosContratuais.folhasGuiaRecebimento
                            ? dadosEngenharia.dadosContratuais.folhasGuiaRecebimento
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Reforma" :xl="xl">
                    <strong>{{
                        dadosEngenharia.dadosContratuais && dadosEngenharia.dadosContratuais.reforma
                            ? dadosEngenharia.dadosContratuais.reforma
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Tipo" :xl="xl">
                    <strong>{{
                        dadosEngenharia.dadosContratuais && dadosEngenharia.dadosContratuais.tipo
                            ? dadosEngenharia.dadosContratuais.tipo
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Classificação de Despesa" :xl="xl">
                    <strong>{{
                        dadosEngenharia.dadosContratuais && dadosEngenharia.dadosContratuais.classificacaoDespesa
                            ? dadosEngenharia.dadosContratuais.classificacaoDespesa
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Fonte de Recurso" :xl="xl">
                    <strong>{{
                        dadosEngenharia.dadosContratuais && dadosEngenharia.dadosContratuais.fonteRecurso
                            ? dadosEngenharia.dadosContratuais.fonteRecurso
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Ação" :xl="xl">
                    <strong>{{
                        dadosEngenharia.dadosContratuais && dadosEngenharia.dadosContratuais.acao
                            ? dadosEngenharia.dadosContratuais.acao
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Sub Ação" :xl="xl">
                    <strong>{{
                        dadosEngenharia.dadosContratuais && dadosEngenharia.dadosContratuais.subacao
                            ? dadosEngenharia.dadosContratuais.subacao
                            : '-'
                    }}</strong>
                </app-detalhe>

                <h5 class="mb-3 mt-4"><strong>Engenharia e fiscalização</strong></h5>
                <app-detalhe titulo="ART Fiscalização" :xl="xl">
                    <strong>{{
                        dadosEngenharia.fiscalizacao && dadosEngenharia.fiscalizacao.artFiscalizacao
                            ? dadosEngenharia.fiscalizacao.artFiscalizacao
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Responsável Técnico" :xl="xl">
                    <strong>{{
                        dadosEngenharia.fiscalizacao && dadosEngenharia.fiscalizacao.responsavelTecnico
                            ? dadosEngenharia.fiscalizacao.responsavelTecnico
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="ART Responsável Técnico" :xl="xl">
                    <strong>{{
                        dadosEngenharia.fiscalizacao && dadosEngenharia.fiscalizacao.artResponsavelTecnico
                            ? dadosEngenharia.fiscalizacao.artResponsavelTecnico
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Data licença Ambiental" :xl="xl">
                    <strong>{{
                        dadosEngenharia.fiscalizacao && dadosEngenharia.fiscalizacao.dataLicencaAmbiental
                            ? formatarData(dadosEngenharia.fiscalizacao.dataLicencaAmbiental)
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Termo de Recebimento" :xl="xl">
                    <strong>{{
                        dadosEngenharia.fiscalizacao && dadosEngenharia.fiscalizacao.termoRecebimento
                            ? dadosEngenharia.fiscalizacao.termoRecebimento
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Data da Proposta" :xl="xl">
                    <strong>{{
                        dadosEngenharia.fiscalizacao && dadosEngenharia.fiscalizacao.dataProposta
                            ? formatarData(dadosEngenharia.fiscalizacao.dataProposta)
                            : '-'
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="CNO" :xl="xl">
                    <strong>{{
                        dadosEngenharia.fiscalizacao && dadosEngenharia.fiscalizacao.cno
                            ? dadosEngenharia.fiscalizacao.cno
                            : '-'
                    }}</strong>
                </app-detalhe>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'Engenharia',

    props: {
        dadosEngenharia: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            xl: 4
        }
    },

    methods: {
        formatarMoeda(valor) {
            if (!valor && valor !== 0) return 'R$ 0,00'
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(valor)
        },

        formatarData(data) {
            if (!data) return '-'
            const dataObj = new Date(data)
            if (isNaN(dataObj.getTime())) return '-'
            return dataObj.toLocaleDateString('pt-BR')
        },

        formatarPercentual(valor) {
            if (valor === null || valor === undefined) return '-'
            return valor.toFixed(2).replace('.', ',') + '%'
        }
    }
}
</script>
